export default "__VITE_ASSET__m1XvjDZv__"